<template>
  <span
    :class="[
      (bulletColor) ? `eyebrow-bullet--${bulletColor}`: '',
      (enableBullet) ? 'eyebrow-bullet' : '',
      (modifier) ? modifier: '',
      textModifiers
    ]"
    class="eyebrow"
    v-html="$cleanRTE(text)"
  />
</template>

<script>

/**
 * Vue: eyebrow (eyebrow)
 * -----------------------------------------------------------------------------
 * small text component that lives above headings.
 *
 */
export default {
  name: 'Eyebrow',
  props: {
    modifier: {
      type: String,
      required: false,
      default: '',
    },
    text: {
      type: String,
      required: false,
      default: '',
    },
    textModifiers: {
      type: String,
      default: 'label',
    },
    bulletColor: {
      type: String,
      required: false,
      default: '',
    },
    enableBullet: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      global: true,
    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    // Not empty
  },
}
</script>
